import React, { ComponentType } from "react"
import { Chip, Grid, Typography } from "@material-ui/core"
import { NodeProps } from "reactflow"

import { BlockNodeData } from "@/protocols/chatBotFlow"

import useRDStationCRMApi from "@/hooks/useRDStationCRMApi"
import useChatBotFlowBlockDetails from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/hooks/useChatBotFlowBlockDetails"
import useDidMount from "@/hooks/useDidMount"
import useChatBotFlowConstructorStore from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/hooks/useChatBotFlowConstructorStore"

import BaseBlock from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BaseBlock"
import BlockBodySection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySection"
import BlockBodySectionContainer from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionContainer"
import AfterActionConditionSection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/AfterActionConditionSection"
import BlockBodySectionGroup from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionGroup"
import PluginStatusReport from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/PluginStatusReport"

import {
	getCurrentRDStationDealUpdate
} from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/utils/chatBotFlowBlockContent"
import ColorUtil from "@/utils/ColorUtil"

import { colors } from "@/styles/colors"
import DealUpdateOptionsSectionEditor from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/resources/Blocks/UpdateRDStationDealBlock/DealUpdateOptionsSectionEditor"

const UpdateRDStationDealBlock: ComponentType<NodeProps<BlockNodeData>> = (node) => {
	const chatBotFlowConstructorStore = useChatBotFlowConstructorStore()
	const isPreview = chatBotFlowConstructorStore.isPreview
	const chatBotFlowBlockDetails = useChatBotFlowBlockDetails({ chatBotFlowBlockId: node.data.chatBotFlowBlockId })
	const currentDealUpdate = getCurrentRDStationDealUpdate(chatBotFlowBlockDetails.content)

	const {
		validatePlugin,
		getValidationContent,
		DEAL_STATUS_OPTIONS
	} = useRDStationCRMApi()

	const pluginStatusContent = getValidationContent()

	const getOptionLabel = () => {
		if (currentDealUpdate) {
			const currentStatusOption = DEAL_STATUS_OPTIONS.find(option => option.slug === currentDealUpdate?.status)

			return (
				<Grid container alignContent="center" justifyContent="center" spacing={1}>
					<Grid item xs={12}>
						<Grid container spacing={1}>
							<Grid item>
								<Typography>
									Funil:
								</Typography>
							</Grid>
							<Grid item>
								<Chip
									label={`${currentDealUpdate?.pipeline.title}`}
									size="small"
									style={{
										...ColorUtil.getBackgroundAndContrastColor(colors.blue[300]),
										borderRadius: "8px",
										color: colors.gray[0],
										fontWeight: "bold"
									}}
								/>
							</Grid>
						</Grid>
					</Grid>

					<Grid item xs={12}>
						<Grid container spacing={1}>
							<Grid item>
								<Typography>
									Etapa:
								</Typography>
							</Grid>
							<Grid item>
								<Chip
									label={`${currentDealUpdate?.stage.title}`}
									size="small"
									style={{
										...ColorUtil.getBackgroundAndContrastColor(colors.blue[300]),
										borderRadius: "8px",
										color: colors.gray[0],
										fontWeight: "bold"
									}}
								/>
							</Grid>
						</Grid>
					</Grid>

					<Grid item xs={12}>
						<Grid container spacing={1}>
							<Grid item>
								<Typography>
									Status:
								</Typography>
							</Grid>
							<Grid item>
								<Chip
									label={`${currentStatusOption?.name}`}
									size="small"
									style={{
										...ColorUtil.getBackgroundAndContrastColor(colors.blue[300]),
										borderRadius: "8px",
										color: colors.gray[0],
										fontWeight: "bold"
									}}
								/>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			)
		} else {
			return ""
		}
	}

	useDidMount(() => {
		validatePlugin()
	})

	return (
		<BaseBlock
			node={node}
		>
			<BlockBodySection
				fullWidth
			>
				{ !isPreview && (
					<PluginStatusReport
						pluginStatusContent={pluginStatusContent}
						onUpdate={async () => {
							await validatePlugin()
						}}
					/>
				)}

				<DealUpdateOptionsSectionEditor
					onSave={content => chatBotFlowBlockDetails.changeContent(content)}
					chatBotFlowBlockContent={chatBotFlowBlockDetails.content}
				>
					<BlockBodySectionContainer
						text={getOptionLabel() || ""}
						placeholder="Selecione um funil de vendas e uma etapa"
						title="Escolha um Funil de Vendas e uma Etapa"
						chatBotFlowBlockId={node?.data?.chatBotFlowBlockId}
					/>
				</DealUpdateOptionsSectionEditor>
			</BlockBodySection>

			<BlockBodySectionGroup>
				<AfterActionConditionSection
					nextChatBotFlowBlockRules={chatBotFlowBlockDetails.nextChatBotFlowBlockRules}
				/>
			</BlockBodySectionGroup>
		</BaseBlock>
	)
}

export default UpdateRDStationDealBlock
